export function FloralBg() {
  return (
    <div className="floral-bg" aria-hidden="true">
      <div className="floral-orb" />
    </div>
  );
}

export function Logo({ size = "text-2xl" }) {
  return (
    <span className={`serif font-bold ${size} tracking-tight flex items-center gap-2`}>
      <span className="text-teal-accent font-mono text-[0.85em]">{"</>"}</span>
      <span><span className="text-white">Kiq</span><span className="text-teal-accent">Hub</span></span>
    </span>
  );
}
